import { GetServerSideProps, NextPage } from 'next';
import { getDataHooksProps } from 'next-data-hooks';
import React from 'react';
import { InstanceDetailStage } from '../../../components/instance-detail/instance-detail-stage/instance-detail-stage';

import { resolveLanguageAndRedirect } from '../../../utils/_helper/resolve-language-and-redirect-helper';
import { setHeaders } from '../../../utils/_helper/set-headers';
import { InstanceDetailPage } from '../../../views/instance-detail-page/instance-detail-page';
import MyApp from '../../_app';

const InstanceDetail: NextPage = () => <InstanceDetailPage />;

export default InstanceDetail;

export const getServerSideProps: GetServerSideProps = async (context) => {
    setHeaders(context);

    const redirect = await resolveLanguageAndRedirect(context);

    if (redirect) return { redirect };
    const dataHooksProps = await getDataHooksProps({
        context,
        dataHooks: [
            ...InstanceDetailPage.dataHooks,
            ...InstanceDetailStage.dataHooks,
            ...MyApp.dataHooks
        ]
    });
    return {
        props: { ...dataHooksProps }
    };
};